import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../header/header.css";
import {
  brand_logo,
  hamburger,
  close_icon,
} from "../../../assets/images/images";

const HomeHeader = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    // Close mobile drawer if open
    if (isDrawerOpen) {
      setIsDrawerOpen(false);
    }
  };

  const menuItems = (
    <ul>
      <li>
        <button className="sign_up_btn_new after_mobile">Sign Up</button>
      </li>
      <li>
        <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
      </li>
      <li>
        <a href="#doctors" onClick={(e) => { e.preventDefault(); scrollToSection('doctors'); }}>Doctors</a>
      </li>
      <li>
        <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>Testimonials</a>
      </li>
      <li>
        <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>Gallery</a>
      </li>
      <li>
        <a href="#awards" onClick={(e) => { e.preventDefault(); scrollToSection('awards'); }}>Awards</a>
      </li>
      <li>
        <Link to="/gallery" className="gallery-nav-link">Full Gallery</Link>
      </li>
    </ul>
  );

  return (
    <>
      {/* Navigation Section */}
      <header className="head_sec_pro_rect">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="head_sec_pro_rect_inner">
                <div className="head_sec_pro_rect_inner_logo">
                  <Link to="/">
                    <img src={brand_logo} alt="brand_logo" />
                  </Link>
                </div>
                <div className="head_sec_pro_rect_inner_menu">
                  <div className="navbar">
                    <ul>
                      <li>
                        <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
                      </li>
                      <li>
                        <a href="#doctors" onClick={(e) => { e.preventDefault(); scrollToSection('doctors'); }}>Doctors</a>
                      </li>
                      <li>
                        <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}>Testimonials</a>
                      </li>
                      <li>
                        <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>Gallery</a>
                      </li>
                      <li>
                        <a href="#awards" onClick={(e) => { e.preventDefault(); scrollToSection('awards'); }}>Awards</a>
                      </li>
                      <li>
                        <Link to="/gallery" className="gallery-nav-link">Full Gallery</Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button className="hamburger-menu" onClick={toggleDrawer}>
                      <img src={hamburger} alt="hamburger_menu" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Drawer Menu */}
      <div className={`drawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <button className="close-btn" onClick={toggleDrawer}>
            {/* <img src={close_icon} alt="close_icon" /> */}
            <p>X</p>
          </button>
        </div>
        <div className="drawer-menu">{menuItems}</div>
      </div>

      {/* Overlay */}
      {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}
    </>
  );
};

export default HomeHeader;
